<template>
  <el-container class='step-container'>
    <el-aside width='200px'>
      <el-page-header class='page-header' @back="back" v-bind:content="title"></el-page-header>
    </el-aside>
    <el-main class='step-main'>
      <el-steps :active="active" class='steps' align-center>
        <el-step v-for='(item, index) in steps' v-bind:key='index' v-bind:title="item"></el-step>
      </el-steps>
    </el-main>
  </el-container>
</template>

<style lang='stylus' scoped>
.step-container{
  margin-bottom 30px
}
.page-header{
  margin-top 20px
}
/deep/ .step-main{
  padding 0
}
.steps{
  margin 0px auto 10px auto
}
</style>

<script>
export default {
  name: 'csteps',
	props: {
    title: {
      type: String,
      default: ''
    },
	  steps: {
		  type: Array,
			default: []
		},
		active: {
		  type: Number,
			default: 0
		}
	},
  methods: {
    back() {
      if(this.active == this.steps.length) {
        this.$router.replace('/')
      }else{
        this.$router.go(-1)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// index.vue?0245be06